import * as actionTypes from "../../constants/actionTypes";
import { getPhoneCategory, getPhoneCategories } from "../../api/phoneCategory";

const invalidatePhoneCategories = () => {
  return {
    type: actionTypes.INVALIDATE_PHONE_CATEGORIES_DATA
  };
};

const loadPhoneCategory = (clientConfig, phoneCategoryId) => {
  return {
    type: actionTypes.LOAD_PHONE_CATEGORY_DATA,
    promise: getPhoneCategory(clientConfig, phoneCategoryId)
  };
};

const loadPhoneCategories = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_CATEGORIES_DATA,
    promise: getPhoneCategories(clientConfig, dataStatus)
  };
};

export { invalidatePhoneCategories, loadPhoneCategory, loadPhoneCategories };
